import {Component, Injector} from "@angular/core";
import {
    AbstractSelectSearchControlComponent
} from "../../framework/entity/search/search-controls/select-search-controls/abstract-select-search-control.component";
import {registerSearchControl} from "../../framework/entity/search/search-controls/abstract-search-control.component";

@Component({
    selector: "wbo-hour-of-day-multi-select-search-control",
    templateUrl: "../../framework/entity/search/search-controls/select-search-controls/multi-select-search-control.component.html",
    providers: [
        registerSearchControl(HourOfDayMultiSelectSearchControlComponent)
    ]
})
export class HourOfDayMultiSelectSearchControlComponent extends AbstractSelectSearchControlComponent<any> {
    constructor(injector: Injector) {
        super(undefined, injector);

        const data: any[] = [];
        for (let index = 0; index < 24; index++) {
            data.push({label: "'" + index + "'", value: index.toString()});
        }

        this.buildData(data);
    }
}
